(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["djw-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('djw-reviews')) {
    customElements.define('djw-reviews', class extends HTMLElement {
      connectedCallback() {
        const row = this.querySelector('[data-row]');
        const prev = this.querySelector('[data-dir="-1"]');
        const next = this.querySelector('[data-dir="1"]');
        if (!row || !prev || !next) return;
        const update = () => {
          const max = row.scrollWidth - row.clientWidth - 2;
          this.classList.toggle('is-static', max <= 0);
          prev.disabled = row.scrollLeft <= 2;
          next.disabled = row.scrollLeft >= max;
        };
        const step = () => {
          const card = row.querySelector('.djw-reviews__card');
          const gap = parseFloat(getComputedStyle(row).columnGap) || 16;
          return card ? card.getBoundingClientRect().width + gap : 340;
        };
        prev.addEventListener('click', () => row.scrollBy({ left: -step(), behavior: 'smooth' }));
        next.addEventListener('click', () => row.scrollBy({ left: step(), behavior: 'smooth' }));
        row.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
